/**
 * get all the cats in all countries, for the init page
 * @param  {obj}    obj  the whole data
 * @return {array}       as below 
 */
/*
[
 {
  name: 'Animals',
  data:[1, 2, 3...]
 },
 {
  name: 'Meat',
  data:[1, 2, 3...]
 }, 
 ...
]
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allCats = allCats;

function allCats(obj) {
  var output = [];
  for (var cat in obj) {
    output.push({
      name: cat,
      data: obj[cat]["total"]
    });
  }

  output.sort(function (a, b) {
    return b.data.reduce(function (b1, b2) {
      return b1 + b2;
    }) - a.data.reduce(function (a1, a2) {
      return a1 + a2;
    });
  });

  return output;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvYWxsQ2F0cy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBa0JPLFNBQVMsT0FBTyxDQUFDLEdBQUcsRUFBQztBQUMxQixNQUFJLE1BQU0sR0FBRyxFQUFFLENBQUE7QUFDZixPQUFJLElBQUksR0FBRyxJQUFJLEdBQUcsRUFBQztBQUNqQixVQUFNLENBQUMsSUFBSSxDQUFDO0FBQ1YsVUFBSSxFQUFFLEdBQUc7QUFDVCxVQUFJLEVBQUUsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDLE9BQU8sQ0FBQztLQUN4QixDQUFDLENBQUE7R0FDSDs7QUFFRCxRQUFNLENBQUMsSUFBSSxDQUFDLFVBQUMsQ0FBQyxFQUFDLENBQUMsRUFBRztBQUNqQixXQUFPLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLFVBQUMsRUFBRSxFQUFFLEVBQUUsRUFBRztBQUFDLGFBQU8sRUFBRSxHQUFHLEVBQUUsQ0FBQTtLQUFDLENBQUMsR0FDOUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsVUFBQyxFQUFFLEVBQUUsRUFBRSxFQUFHO0FBQUMsYUFBTyxFQUFFLEdBQUcsRUFBRSxDQUFBO0tBQUMsQ0FBQyxDQUFBO0dBQzVDLENBQUMsQ0FBQTs7QUFFRixTQUFPLE1BQU0sQ0FBQTtDQUNkIiwiZmlsZSI6Ii9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvYWxsQ2F0cy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogZ2V0IGFsbCB0aGUgY2F0cyBpbiBhbGwgY291bnRyaWVzLCBmb3IgdGhlIGluaXQgcGFnZVxuICogQHBhcmFtICB7b2JqfSAgICBvYmogIHRoZSB3aG9sZSBkYXRhXG4gKiBAcmV0dXJuIHthcnJheX0gICAgICAgYXMgYmVsb3cgXG4gKi9cbi8qXG5bXG4ge1xuICBuYW1lOiAnQW5pbWFscycsXG4gIGRhdGE6WzEsIDIsIDMuLi5dXG4gfSxcbiB7XG4gIG5hbWU6ICdNZWF0JyxcbiAgZGF0YTpbMSwgMiwgMy4uLl1cbiB9LCBcbiAuLi5cbl1cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGFsbENhdHMob2JqKXtcbiAgbGV0IG91dHB1dCA9IFtdXG4gIGZvcihsZXQgY2F0IGluIG9iail7XG4gICAgb3V0cHV0LnB1c2goe1xuICAgICAgbmFtZTogY2F0LCBcbiAgICAgIGRhdGE6IG9ialtjYXRdW1widG90YWxcIl1cbiAgICB9KVxuICB9XG5cbiAgb3V0cHV0LnNvcnQoKGEsYik9PntcbiAgICByZXR1cm4gYi5kYXRhLnJlZHVjZSgoYjEsIGIyKT0+e3JldHVybiBiMSArIGIyfSkgXG4gICAgLSBhLmRhdGEucmVkdWNlKChhMSwgYTIpPT57cmV0dXJuIGExICsgYTJ9KSBcbiAgfSlcbiAgXG4gIHJldHVybiBvdXRwdXRcbn0iXX0=